// removed by extract-text-webpack-plugin
module.exports = {"active":"new-options-sidebar--active--25mXRbg_","option":"new-options-sidebar--option--UE91q-4R"};


//////////////////
// WEBPACK FOOTER
// ./components/new-options-sidebar/styles.css
// module id = ./components/new-options-sidebar/styles.css
// module chunks = 0